"use client";

import Link from "next/link";
import { Timer } from "lucide-react";
import ImageComponent from "@core/helpers/server/components/image";

const read_url = (value) => {
    if (!value || typeof value !== "object") return "";

    return (
        value?.url ||
        value?.link ||
        value?.seo?.full_url ||
        value?.seo?.url ||
        value?.seo_id?.url ||
        ""
    );
};

const CATEGORY_CHIP_CLASS =
    "inline-flex items-center justify-center whitespace-nowrap min-h-6 rounded-full border border-white/80 bg-black/20 px-1.5 py-0.5 text-xs font-bold text-white backdrop-blur-xs";

export default function BlogCard({ blog, storage_prefix_url }) {
    const categoryTitle =
        blog?.["title-category"]?.title ||
        blog?.["link-category-special-blog"]?.model_title ||
        "";

    const categoryUrl = read_url(blog?.["link-category-special-blog"]);

    const blogUrl =
        read_url(blog?.["link-title-blog"]) ||
        read_url(blog?.["undefined"]) ||
        "#";

    const readingTime =
        blog?.readingtime || blog?.createdAt || "۲ دقیقه مطالعه";

    return (
        <article
            className="group relative block w-full max-h-[312px] aspect-square overflow-hidden rounded-md bg-jmt-neutral-900 transition-all duration-300"
            dir="rtl"
        >
            <Link
                href={blogUrl}
                aria-label={blog?.["title-blog"] || ""}
                className="absolute inset-0 z-1"
            >
                <ImageComponent
                    src={blog?.["image-special-blog"]?.url || ""}
                    alt={
                        blog?.["image-special-blog"]?.alt ||
                        blog?.["title-blog"] ||
                        ""
                    }
                    width={100}
                    height={100}
                    style={{ width: "100%", height: "100%" }}
                    className="object-cover transition-transform duration-500 ease-out group-hover:scale-105"
                    storage_prefix_url={storage_prefix_url}
                />
            </Link>

            <div className="pointer-events-none absolute inset-0 z-2 bg-linear-to-t from-black/85 via-black/40 to-transparent transition-opacity duration-300 group-hover:from-black/95" />

            <div className="pointer-events-none absolute inset-0 z-3 flex flex-col justify-end p-4 text-white">
                <Link
                    href={blogUrl}
                    className="pointer-events-auto line-clamp-2 text-right text-sm font-bold leading-6 text-white transition-colors duration-300 hover:text-neutral-200"
                >
                    {blog?.["title-blog"]}
                </Link>

                <div className="mt-2.5 flex items-center justify-between gap-2 text-xs">

                    {categoryTitle &&
                        (categoryUrl ? (
                            <Link
                                href={categoryUrl}
                                onClick={(e) => e.stopPropagation()}
                                className={`pointer-events-auto transition-all hover:bg-white hover:text-black ${CATEGORY_CHIP_CLASS}`}
                            >
                                {categoryTitle}
                            </Link>
                        ) : (
                            <span className={CATEGORY_CHIP_CLASS}>{categoryTitle}</span>
                        ))}

                    {readingTime && (
                        <div className="flex items-center gap-1 text-xs font-normal text-jmt-neutral-200">
                            <span>{readingTime}</span>
                            <Timer size={16} />
                        </div>
                    )}
                </div>
            </div>
        </article>
    );
}
